module.exports = __webpack_public_path__ + "static/media/house.a03f12f2.svg";